const el = {
  trigger: document.querySelector<HTMLButtonElement>('.checkout-footer__trigger'),
  summary: document.querySelector<HTMLDivElement>('.checkout-sidebar'),
  footer: document.querySelector<HTMLDivElement>('.footer'),
  overlay: document.querySelector<HTMLDivElement>('.overlay'),
  header: document.querySelector<HTMLElement>('.header'),
  checkoutFooter: document.querySelector<HTMLElement>('.checkout-footer'),
}

export const CheckoutSummary = {
  init: () => {
    if (!el.summary || !el.trigger) return
    el.trigger.addEventListener('click', CheckoutSummary.toggleSummary)
    window.addEventListener('resize', CheckoutSummary.onResize)
    if (el.overlay) el.overlay.addEventListener('click', CheckoutSummary.closeSummary)
  },

  toggleSummary: (e: Event & { target: HTMLButtonElement }) => {
    if (e.target.classList.contains('checkout-footer__trigger--open')) {
      CheckoutSummary.closeSummary()
      return
    }
    CheckoutSummary.openSummary()
  },

  openSummary: () => {
    CheckoutSummary.adjustScrollPosition()
    if (el.trigger) el.trigger.classList.add('checkout-footer__trigger--open')
    el.summary.classList.add('checkout-sidebar--open')
    document.body.classList.add('h-disable-scroll')
    if (el.overlay) el.overlay.classList.add('overlay--visible')
    if (el.header) el.header.style.zIndex = '3'
    if (el.checkoutFooter) el.checkoutFooter.style.zIndex = '5'
  },

  closeSummary: () => {
    if (el.trigger) el.trigger.classList.remove('checkout-footer__trigger--open')
    el.summary.classList.remove('checkout-sidebar--open')
    document.body.classList.remove('h-disable-scroll')
    if (el.overlay) el.overlay.classList.remove('overlay--visible')
    if (el.header) el.header.style.zIndex = ''
    if (el.checkoutFooter) el.checkoutFooter.style.zIndex = ''
  },

  onResize: () => {
    const { innerWidth } = window
    if (innerWidth >= 992) {
      if (el.summary && el.summary.classList.contains('checkout-sidebar--open')) {
        CheckoutSummary.closeSummary()
      }
    }
  },

  adjustScrollPosition: () => {
    if (!el.footer) return
    const { top } = el.footer.getBoundingClientRect()

    // if top of footer is visible on the page we have to calculate the distance to scroll
    // to set the checkout footer in the right place
    if (top < window.innerHeight) {
      try {
        const distanceToScroll =
          document.documentElement.scrollHeight -
          window.innerHeight -
          el.footer.clientHeight
        window.scrollTo(0, distanceToScroll)
      } catch (_) {
        window.scrollTo(0, 0)
      }
    }
  },
}
